export default "__VITE_ASSET__2dd626cc__"